<template lang="pug">
.d-flex
  .flex-grow-1
    filter-name.mr-2(:filter.sync="nameFilter")
    filter-date.mr-2(:filter.sync="createdFilter" title="Created date" param="created_date")
    filter-inventory(:filter.sync="inventoryFilter")
  v-btn.button-sm.underline.px-0(text @click="resetFilters" :disabled="allFilters.length === 0") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterDate from '@/components/module/filter/FilterDate.vue'
import FilterInventory from '@/components/module/filter/FilterInventory.vue'

export default {
  name: 'FilterServicesRow',
  components: { FilterName, FilterDate, FilterInventory },
  props: ['filters'],
  data: () => ({
    nameFilter: {},
    createdFilter: {},
    inventoryFilter: {},
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.createdFilter.key) {
        if (this.createdFilter.key === 'between') {
          const values = this.createdFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.createdFilter)
        }
      }
      if (this.inventoryFilter.key) {
        if (this.inventoryFilter.key === 'between') {
          const values = this.inventoryFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.inventoryFilter)
        }
      }
      return filters
    }
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
    resetFilters () {
      this.nameFilter = {}
      this.createdFilter = {}
      this.inventoryFilter = {}
    }
  }
}
</script>